import { SubscriberLookupResolveService } from './shared/services/subscriber-lookup-resolve.service';
import { CommonModule } from '@angular/common';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriberShellComponent } from '@admin/subscribers/subscriber-shell/subscriber-shell.component';
import { SubscriberListComponent } from '@admin/subscribers/subscriber-list/subscriber-list.component';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'subscribers',
    component: SubscriberShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: SubscriberLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: SubscriberListComponent,
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubscribersRoutingModule {}
